import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';

// Translations
import translate from '../Translate.js';

// Dependencies
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

// Components
import PendingSessionList from './PendingSessionList';

const PendingSessions = observer(class PendingSessions extends React.Component {
  constructor() {
    super();
    this.handleTabs = this.handleTabs.bind(this);
  }

  componentWillMount() {
    this.state = {
      activeTab: 1,
    }

    this.getPending('request', 'createdDate');
  }

  getPending(status, sortKey) {
    this.props.store.ScheduleStore.getPendingSessions(status, sortKey);
  }

  handleTabs(index) {
    this.setState({
      activeTab: index + 1,
    })
  }

  render() {
    const { translation } = this.props;

    // Don’t use the default tab styles
    Tabs.setUseDefaultStyles(false);

    return (
      <div>
        {this.props.root &&
          <header className="page__header">
            <h1 className="page__title">{translation.heading}</h1>

            <Link
              className="page__link"
              to="sessions"
            >
              {translation.upcoming}
            </Link>
          </header>
        }

        {!this.props.root &&
          <h2 className="page__title">{translation.heading}</h2>
        }

        <Tabs
          onSelect={this.handleTabs}
        >
          <TabList>
            <Tab onClick={() => this.getPending('request', 'createdDate')}>
              {translation.action_required}
            </Tab>
            <Tab onClick={() => this.getPending('pending', 'confirmedDateExpiration')}>
              {translation.awaiting_student}
            </Tab>
          </TabList>

          <TabPanel>
            <PendingSessionList type="request" {...this.props} />
          </TabPanel>

          <TabPanel>
            <PendingSessionList type="pending" {...this.props} />
          </TabPanel>
        </Tabs>
      </div>
    );
  }
})

export default translate('PendingSessions')(PendingSessions);


// WEBPACK FOOTER //
// ./src/app/components/Sessions/PendingSessions.js